// extracted by mini-css-extract-plugin
export default {"prev":"styles_prev__jjbn1","next":"styles_next__MbGnn"};